import { Divider } from '@renderer-ui-library/mui';
import styles from './menuDivider.module.scss';

export const MenuDivider: React.FC = () => (
    <div className={styles.divider}>
        <Divider />
    </div>
);
